import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { openInAppTab } from "../../utils/tabNavigation";

function ClosedCandidates({ client_id , onClose }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [candidates, setCandidates] = useState([]);
  useEffect(() => {
    if (!client_id) return; // Don't call if no client_id
    const fetchClosedCandidates = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/roles/get_closed_candidates/${client_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCandidates(response.data.candidates);
      } catch (error) {
        console.log("Error fetching closed candidates:", error);
        setGlobalLoading(false);
        setCandidates([]);
      } finally {
        setGlobalLoading(false);
      }
    };
    fetchClosedCandidates();
  }, [client_id]);

  const columns = [
    {
      accessorKey: "candidate_id",
      header: "Candidate Name",
      size: 300,
      Cell: ({ row }) => {
        return (
          <div className="d-flex align-items-center">
            <Link
              to={`/candidates/view/${row.original.candidate_id}`}
              target="_blank"
              className="avatar avatar-md border avatar-rounded"
              onClick={(event) => {
                event.preventDefault();
                openInAppTab(
                  `/candidates/view/${row.original.candidate_id}`,
                );
              }}
            >
              {row.original.userpic ? (
                <img
                  src={`${PINE_BASE_URL}/files/candidates/picture/${row.original.userpic}`}
                  className="img-fluid"
                  alt="img"
                />
              ) : (
                <img
                  src="https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-39.jpg"
                  className="img-fluid"
                  alt="img"
                />
              )}
            </Link>
            <div className="ms-2">
              <h6 className="fw-medium fs-12 mbm-12">
                <Link
                  to={`/candidates/view/${row.original.candidate_id}`}
                  target="_blank"
                  onClick={(event) => {
                    event.preventDefault();
                    openInAppTab(
                      `/candidates/view/${row.original.candidate_id}`,
                    );
                  }}
                >
                  {row.original.firstname} {row.original.lastname}
                </Link>
              </h6>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "role_name",
      header: "Role",
      size: 200,
    },
    {
      accessorKey: "change_status",
      header: "Joining Date",
      size: 200,
    },
  ];

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Contact Details</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              >
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xxl-12 col-lg-12 col-md-6">
                  <div className="card">
                    <div className="card-body my-card-body">
                      <MaterialReactTable
                        data={candidates}
                        columns={columns}
                        initialState={{
                          pagination: { pageSize: 100 },
                        }}
                        muiTableBodyRowProps={{
                          sx: {
                            height: "32px", // compact row height
                          },
                        }}
                        muiTableBodyCellProps={{
                          sx: {
                            padding: "4px 8px", // compact cell padding
                          },
                        }}
                        muiTableHeadCellProps={{
                          sx: {
                            padding: "4px 8px", // same as body cells
                            height: "32px", // or less
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClosedCandidates;
